import { useSetting } from "../hooks/SettingsHooks";
import Helmet from "react-helmet";

const DocumentTitle = ({ title }) => {
  const titleSuffix = useSetting("title_suffix");
  return (
    <Helmet defer={false}>
      <title>{title + titleSuffix}</title>
    </Helmet>
  );
};

export default DocumentTitle;
